import { cmsLocale } from '../i18n/locale';

export const CMS_URL = 'https://test.cms.soft99.eu';

export function cmsUrl(path, locale = cmsLocale) {
  const url = new URL(path.replace(/^\//, ''), `${CMS_URL}/`);
  url.searchParams.set('_locale', locale);
  return url.toString();
}

export async function fetchContent(path, locale = cmsLocale) {
  const response = await fetch(cmsUrl(path, locale));
  if (response.status === 404) return null;
  if (!response.ok) throw new Error(`Strapi: ${response.status}`);
  const data = await response.json();
  // Refuse a default-language response from a misconfigured CMS.
  if (Array.isArray(data)) return data.filter(item => item.locale === locale);
  return data && data.locale === locale ? data : null;
}

export function getServicePath(service) {
  return service?.garage_category?.path && service?.path
    ? `/${service.garage_category.path}/${service.path}` : null;
}

export function bookingServiceId(service) {
  return service?.localizations?.find(item => item.locale === 'pl-PL')?.id || service?.id;
}

// Localizations have separate Strapi IDs. Only routing/booking identity comes
// from the Polish entry; German display fields always come from the German one.
export function normalizeService(service, originals = []) {
  const sourceId = bookingServiceId(service);
  const source = originals.find(item => item.id === sourceId);
  return {
    ...service,
    sourceId,
    sourceTitle: source?.title || service.title,
    sourcePath: getServicePath(source) || getServicePath(service),
    categoryType: source?.garage_category?.type || service.garage_category?.type,
  };
}

const serviceRequests = new Map();
export function fetchServices(locale = cmsLocale) {
  if (!serviceRequests.has(locale)) {
    const request = Promise.all([
      fetchContent('garage-services', locale),
      locale === 'pl-PL' ? Promise.resolve([]) : fetchContent('garage-services', 'pl-PL'),
    ]).then(([items, originals]) => (items || [])
      .filter(getServicePath)
      .map(item => normalizeService(item, originals || [])))
      .catch(error => { serviceRequests.delete(locale); throw error; });
    serviceRequests.set(locale, request);
  }
  return serviceRequests.get(locale);
}
